import React from 'react';
import Navbar from './components/Navbar';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  return (
    <>
      <Navbar />
      {/* Outlet renderiza solo lo que cambia según la ruta */}
      <Outlet />
    </>
  );
};

export default Layout;
